import { ReactNode } from "react";
import styles from "./Container.module.scss";

interface ContainerProps {
  children: ReactNode;
  maxWidth?: string; // optional override of max-width
}

const Container = ({ children, maxWidth = "568px" }: ContainerProps) => (
  <div className={styles.container}>
    <div className={styles.mobileWebExtraSpace} style={{ maxWidth }}>
      {children}
    </div>
  </div>
);

export default Container;
